module.exports = __webpack_public_path__ + "img/path-6.fd1fb408.svg";